import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sync", "continue"];

  declare readonly syncTargets: HTMLInputElement[];
  declare readonly continueTarget: HTMLButtonElement;

  connect() {
    this.update();
  }

  update() {
    const count = this.syncTargets.filter((input) => input.checked).length;
    this.continueTarget.textContent = count === 0
      ? "Continue without importing"
      : `Import ${count} ${count === 1 ? "account" : "accounts"}`;
  }
}
